import { parseTimeFromSeconds } from "../parseTimeFromSeconds";
/**
 * @return {string} Formated string MM'
 * @param {number} ms Milliseconds to convert
 */
export const parseTimeFromMilliseconds = (ms) => {
    let toSeconds = Math.ceil(Math.abs(ms) / 1000);
    return parseTimeFromSeconds(toSeconds);
};
//# sourceMappingURL=parseTimeFromMilliseconds.js.map